import CommonCRUD from "modules/CommonCRUD";

class Orders extends CommonCRUD {
    async recalcOrder(orderId, isRefreshingDataFromProvider = false, isUseOffer = false) {
        return await this.api.fetch({
            method: "post",
            url: `/${this.schema}/${orderId}/recalc`,
            data: {
                isRefreshingDataFromProvider,
                isUseOffer,
            },
        });
    }

    async repost(orderId) {
        return await this.api.fetch({
            method: "post",
            url: `/${this.schema}/${orderId}/repost`,
        });
    }

    async connectOrder(orderId, data) {
        const res = await this.api.fetch({
            returnBody: true,
            method: "post",
            url: `/${this.schema}/${orderId}/select-provider`,
            data,
        });
        return res;
    }
}

export default Orders;
